import { faFaceAwesome } from '@fortawesome/pro-solid-svg-icons'

import { SecondaryButton } from 'Components/_theme'

import { Heading } from '../Heading/Heading'

export const SecondaryButtonPresentation = () => (
  <div>
    <Heading size={4}>Secondary Buttons:</Heading>
    <Heading size={5}>Medium: </Heading>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Secondary Button Medium *** */}

      <SecondaryButton size="medium"> SecM Button </SecondaryButton>

      {/* *** Secondary Button Medium icon Left *** */}

      <SecondaryButton iconLeft={faFaceAwesome} size="medium">
        SecM Button
      </SecondaryButton>

      {/* *** Secondary Button Medium icon Right *** */}

      <SecondaryButton iconRight={faFaceAwesome} size="medium">
        SecM Button
      </SecondaryButton>

      {/* *** Secondary Button Medium icon Both *** */}

      <SecondaryButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="medium"
      >
        SecM Button
      </SecondaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Secondary Button Medium Disabled *** */}

      <SecondaryButton disabled size="medium">
        SecM Button
      </SecondaryButton>

      {/* *** Secondary Button Medium Disabled icon Left *** */}

      <SecondaryButton disabled iconLeft={faFaceAwesome} size="medium">
        SecM Button
      </SecondaryButton>

      {/* *** Secondary Button Medium Disabled icon Right *** */}

      <SecondaryButton disabled iconRight={faFaceAwesome} size="medium">
        SecM Button
      </SecondaryButton>

      {/* *** Secondary Button Medium Disabled icon Both *** */}

      <SecondaryButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="medium"
      >
        SecM Button
      </SecondaryButton>
    </div>

    <Heading size={5}>Large: </Heading>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Secondary Button Large *** */}

      <SecondaryButton size="large">SecL Button</SecondaryButton>

      {/* *** Secondary Button Large icon Left *** */}

      <SecondaryButton iconLeft={faFaceAwesome} size="large">
        SecL Button
      </SecondaryButton>

      {/* *** Secondary Button Large icon Right *** */}

      <SecondaryButton iconRight={faFaceAwesome} size="large">
        SecL Button
      </SecondaryButton>

      {/* *** Secondary Button Large icon Both *** */}

      <SecondaryButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="large"
      >
        SecL Button
      </SecondaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Secondary Button Large Disabled *** */}

      <SecondaryButton disabled size="large">
        SecL Button
      </SecondaryButton>

      {/* *** Secondary Button Large Disabled icon Left *** */}

      <SecondaryButton disabled iconLeft={faFaceAwesome} size="large">
        SecL Button
      </SecondaryButton>

      {/* *** Secondary Button Large Disabled icon Right *** */}

      <SecondaryButton disabled iconRight={faFaceAwesome} size="large">
        SecL Button
      </SecondaryButton>

      {/* *** Secondary Button Large Disabled icon Both *** */}

      <SecondaryButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="large"
      >
        SecL Button
      </SecondaryButton>
    </div>

    <Heading size={5}>Small: </Heading>
    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Secondary Button Small *** */}

      <SecondaryButton size="small">SecS Button</SecondaryButton>

      {/* *** Secondary Button Small icon Left *** */}

      <SecondaryButton iconLeft={faFaceAwesome} size="small">
        SecS Button
      </SecondaryButton>

      {/* *** Secondary Button Small icon Right *** */}

      <SecondaryButton iconRight={faFaceAwesome} size="small">
        SecS Button
      </SecondaryButton>

      {/* *** Secondary Button Small icon Both *** */}

      <SecondaryButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="small"
      >
        SecS Button
      </SecondaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Secondary Button Small Disabled *** */}

      <SecondaryButton disabled size="small">
        SecS Button
      </SecondaryButton>

      {/* *** Secondary Button Small Disabled  icon Left *** */}

      <SecondaryButton disabled iconLeft={faFaceAwesome} size="small">
        SecS Button
      </SecondaryButton>

      {/* *** Secondary Button Small Disabled  icon Right *** */}

      <SecondaryButton disabled iconRight={faFaceAwesome} size="small">
        SecS Button
      </SecondaryButton>

      {/* *** Secondary Button Small Disabled  icon Both *** */}

      <SecondaryButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="small"
      >
        SecS Button
      </SecondaryButton>
    </div>
  </div>
)
